import { Injectable } from "@angular/core";
import { AlertController, AlertOptions } from "@ionic/angular";
import { ZipCodeOptions } from "../models/zipcode-options.interface";

@Injectable({
    providedIn: 'root'
})
export class ZipCodeController {

    constructor(
        private alertController: AlertController
    ) { }

    async showAlert(zipOptions: ZipCodeOptions): Promise<string> {
        return new Promise<string>(async (resolve) => {
            let zipcode = '';
            const alertOptions: AlertOptions = {
                header: '',
                subHeader: '',
                message: `
            <img src="assets/svg/address-icon.svg" width="20px" height="20px" class="alert-icon" />
            <p>${zipOptions.message || ''}</p>
            `,
                backdropDismiss: false,
                inputs: [
                    { type: 'text', name: 'zipcode', placeholder: "Código postal" }
                ],
                cssClass: 'custom-alert-explore',
                buttons: []
            };

            alertOptions.buttons?.push({
                text: zipOptions.confirm?.text || '',
                role: 'confirm',
                cssClass: 'alert-button-explore',
                handler: (res) => {
                    if (!res.zipcode) {
                        window.location.reload();
                        resolve('');
                    } else {
                        resolve(res.zipcode);
                    }                    
                }
            });

            const alert = await this.alertController.create(alertOptions);
            await alert.present();
        });
    }

}